<template>
    <section v-if="loadChart">
        <div class="panel">
            <h2 class="h3 text-bold">
                Market Statistics
            </h2>
            <p class="f4">
                Median List Price
            </p>
            <mvtLazyload ref="marketchart" :async="true" data-role="marketchart">
                <mvtMarket @completed="completed" :cityId="dsp.geo.cityId" :countyId="dsp.geo.countyId" :state="dsp.geo.state" :city="dsp.geo.city" :county="dsp.geo.county" ></mvtMarket>
            </mvtLazyload>
        </div>
    </section>
</template>
<script src="./dsp-market.js"></script>
<style lang="scss">
@use "./dsp-market.scss" as *;
</style>